import React from 'react';
import './Static.css';

const TermsOfConditions = () => {
  return (
    <div>
      <h2>Use at your own risk.</h2>
      <h4>You are responsible for ensuring that you are eligible to vote, that the information you provide is correct and that the information is correct before you submit your voter registration form.</h4>
      <p>This app will NOT save any of your data. Please print or download your form after completing the form so that you may send it to your state to be registered.</p>
    </div>
  )
}

export default TermsOfConditions;



// WEBPACK FOOTER //
// ./src/components/staticComponents/TermsOfConditions.js